export type Tutor = { name: string; title: string };
export type Letter = {
  quote: string;
  name: string;
  course: string;
  date: string;
};

export const tutorRows: Tutor[][] = [
  [
    { name: "Rory Sutherland", title: "Vice Chairman, Ogilvy" },
    { name: "Dan Ariely", title: "Professor, Duke University" },
    { name: "Sir John Hegarty", title: "Founder, BBH" },
    { name: "Dave Trott", title: "Advertising Legend" },
    { name: "Sir Martin Sorrell", title: "Chairman, S4 Capital" },
    { name: "Les Binet", title: "Head of Effectiveness, adam&eveDDB" },
    { name: "Benedict Evans", title: "World-renowned Tech Analyst" },
    { name: "Meik Wiking", title: "CEO, Happiness Research Institute" },
  ],
  [
    { name: "Josy Paul", title: "Chairman, BBDO India" },
    { name: "Frank Cooper III", title: "CMO, BlackRock" },
    { name: "Nils Leonard", title: "Founder, Uncommon" },
    { name: "Steve Harrison", title: "ex-Global ECD, Wunderman" },
    { name: "Will Awdry", title: "Writing Coach & Strategist" },
    { name: "Orlando Wood", title: "CSO, System1" },
    { name: "Dan Bennett", title: "Head of Behavioural Science, Ogilvy" },
    { name: "Fonz Morris", title: "Lead Designer, Netflix" },
  ],
  [
    { name: "Kathryn Jacob OBE", title: "CEO, Pearl & Dean" },
    { name: "Vicki Maguire", title: "CCO, Havas" },
    { name: "Vikki Ross", title: "Brand & Tone of Voice Consultant" },
    { name: "Anna Vogt", title: "Global CSO, Edelman" },
    { name: "Tyrona Heath", title: "Co-Founder, B2B Institute at LinkedIn" },
    { name: "Amanda Feve", title: "Partner & CSO, Anomaly" },
    { name: "Jane Evans", title: "Founder, The Uninvisibility Project" },
    { name: "James Rosenthal", title: "Director of AI Infrastructure, Google" },
  ],
];

export const letters: Letter[] = [
  {
    quote:
      "The personalised experience was brilliant. The explanation in the lessons calling my name every now and then always made me smile and think, yes, this is for me.",
    name: "Banu Abdulrahman",
    course: "Copywriting",
    date: "April 2026",
  },
  {
    quote:
      "After passing this course, I feel more confident about running ads using behavioural economics, especially heuristics, biases, norms, and other behavioural traits.",
    name: "Jawahar Kaushal",
    course: "Behavioural Economics",
    date: "December 2024",
  },
  {
    quote:
      "It helped me think about how to use AI in ways I had not considered before and I have already started integrating some of them into my day-to-day work.",
    name: "Daniel Palmer",
    course: "AI for Marketers",
    date: "December 2025",
  },
  {
    quote:
      "The course was insightful and engaging. I loved how it combined practical exercises with thought-provoking concepts, making creativity feel more accessible.",
    name: "Stephen Ogunleye",
    course: "Creative Thinking",
    date: "March 2025",
  },
  {
    quote:
      "I just wanted to thank the 42courses crew for taking the time to actually review and comment on my answers. This is greatly appreciated.",
    name: "Olivier Croisier",
    course: "Behavioural Economics",
    date: "March 2025",
  },
];
